"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPhoneOpen = function SvgPhoneOpen(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 3H.5M6 0l2 3-2 3M18.23.838c.497.443.809.722.936.837.707.629.82 1.519.342 2.67-.718 1.726-3.41 5.889-9.272 9.407-1.294.91-2.456.705-2.99 0a72.88 72.88 0 0 0-1.046-1.35c-.38-.586-.22-1.13.48-1.632 1.048-.753.713-.487 1.57-1.075.857-.587.85-.456 1.986 0 1.136.456 1.147.854 2.273-.22a83.9 83.9 0 0 0 2.885-2.938c.44-.413.44-.929 0-1.547-.66-.927-.66-1.283 0-2.3A19.55 19.55 0 0 1 16.752.838c.49-.443.982-.443 1.478 0z",
    fill: "none",
    stroke: "#007AFF"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPhoneOpen);
var _default = exports["default"] = Memo;